Packlab.Mixin.register('has-slot', {
    methods: {
        hasSlot(slot) {
            return typeof this.$slots[slot] !== "undefined";
        }
    }
});